import { useEffect } from 'react'
import { isSafari } from 'react-device-detect'

import { toFixedNum } from 'helpers/number'
import { logger } from 'utils/logger'

const INTERVAL = 600000 // 10 minutes

const useHeapLogger = () => {
    useEffect(() => {
        if (isSafari) return
        const usedJSHeapSize =
            performance?.memory?.usedJSHeapSize / Math.pow(1000, 2) //MB
        const jsHeapSizeLimit =
            performance?.memory?.jsHeapSizeLimit / Math.pow(1000, 2) //MB
        const usagePercentage = toFixedNum(
            (usedJSHeapSize / jsHeapSizeLimit) * 100
        )

        const { deviceMemory } = navigator || {}
        const memInfo = {
            usedJSHeapSize,
            deviceMemory,
            jsHeapSizeLimit,
            usagePercentage,
        }

        const memStr = `[memory] ${JSON.stringify(memInfo)}`

        const id = setInterval(() => {
            if (!navigator.onLine) {
                clearInterval(id)
                return
            }
            logger.info(memStr)
        }, INTERVAL)

        return () => clearInterval(id)
    }, [])
}

export default useHeapLogger
